import { FC } from 'react'
import { ITestImageMatching } from 'shared/types'
import { HStack, Box, AspectRatio, Image } from '@chakra-ui/react'
import ImageField from 'components/formFields/ImageField'
import { ReactComponent as IconX } from 'shared/assets/bsXCircle.svg'
// import { ReactComponent as IconList } from 'shared/assets/bsList.svg'
import SimpleInput from 'shared/components/SimpleInput'

type Props = {
  item: ITestImageMatching
  onChangeRow: (item: ITestImageMatching) => void
  onDelete: (id: string) => void
}

const EditTestMatchWithImagesRow: FC<Props> = ({
  item,
  onChangeRow,
  onDelete
}) => {
  const onChangeImageUrl = (v: string) => {
    onChangeRow({ ...item, imageUrl: v })
  }

  return (
    <HStack w='full' key={item.id} spacing={6}>
      {/* <Box>
        <IconList width='14' height='14' />
      </Box> */}
      <Box w='24' borderWidth={1} borderColor={'wood.100'}>
        <AspectRatio ratio={1} maxW={'full'} w='full'>
          <Image fit='cover' src={item.imageUrl} />
        </AspectRatio>
      </Box>
      <Box>
        <ImageField
          value={item.imageUrl}
          onChange={(v: string) => onChangeImageUrl(v)}
          storagePath={`/sections/${item.id}`}
        />
      </Box>
      <SimpleInput
        value={item.word}
        onChange={(v: string) => onChangeRow({ ...item, word: v })}
      />
      <Box
        textStyle={{ base: 'tag', lg: 'small' }}
        as='button'
        onClick={() => onDelete(item.id)}
        color='red.700'
      >
        <IconX width='14' height='14' />
      </Box>
    </HStack>
  )
}

export default EditTestMatchWithImagesRow
